import React from 'react'
import { DataTable } from './DataTable'
import { Button } from 'antd'
import { YhBox } from '@/components/YhBox'
import { useLedgerModel } from '../ledgerModel'
import './statistics.less'

export const DataBox = () => {
    const { ledgerExport, selectedRowKeys } = useLedgerModel()

    const action = (
        <>
            <Button style={{ marginBottom: '10px' }} shape="round" type="link" onClick={ledgerExport} disabled={selectedRowKeys.length < 1}>
                {' '}
                导出{' '}
            </Button>
        </>
    )
    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 230px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
